import Helpers from '../helpers';

export default class SameSiteCheckCore {
	/**
	 * 校验是否为 samesite 问题
	 * 校验规则(同时满足)：
	 * 1、当前浏览器为 Chrome 且版本大于 80
	 * 2、接口请求与当前页面地址为非同站
	 * @param urlStackInfo
	 */
	static check (urlStackInfo: Record<string, any>[]): boolean {
		let currentDomain = window.location && window.location.hostname;
		let apiDomains = this.getAllApiDomains(urlStackInfo);
		let isNotSameSite = apiDomains.some((domain: string): boolean => {
			return this.checkIsNotSameSite(domain, currentDomain);
		});
		let isOver80Chrome = this.checkIsOver80Chrome();
		return isNotSameSite && isOver80Chrome;
	}
	/**
	 * 获取所有 api domain
	 * @param urlStackInfo url 堆栈信息
	 */
	static getAllApiDomains (urlStackInfo: Record<string, any>[]): string[] {
		let res: string[] = [];
		urlStackInfo.forEach((info: Record<string, any>): void => {
			let apiDomains = info.apiDomains;
			if (!Array.isArray(apiDomains) || !apiDomains.length) return;
			res = res.concat(apiDomains);
		});
		let set: Set<string> = new Set<string>(res);
		res = Array.from(set);
		return res;
	}
	/**
	 * 校验是否非同站
	 * 同站标准：二级域名 + 顶级域名相等
	 * @param apiDomain
	 * @param currentDomain
	 */
	static checkIsNotSameSite (apiDomain: string, currentDomain: string): boolean {
		let currentSite: string = '';
		let length: number;
		currentDomain.split('.').forEach((val: string, index: number, array: string[]): void => {
			if (index >= array.length - 2) currentSite += val + '.';
		});
		currentSite = '.' + currentSite.slice(0, currentSite.length - 1);
		length = currentSite.length;
		return apiDomain.indexOf(currentSite) !== apiDomain.length - length;
	}
	/**
	 * 校验浏览器版本是否为 80 版本以上的 Chrome
	 */
	static checkIsOver80Chrome (): boolean {
		return Helpers.getChromeVersion() >= 80;
	}
}
